
document.addEventListener('DOMContentLoaded', () => {
  const slides = document.querySelectorAll('.js-slide');
  
  // 環境設定: trueなら開発環境、falseなら本番環境
  const isDevelopment = false; 
  
  // ログ関数: 環境に応じて出力を切り替える
  const log = (type, message) => {
    if (isDevelopment) {
      if (type === 'error') console.error(message);
      else if (type === 'warn') console.warn(message);
      else console.log(message);
    }
  };

  // スライドが存在しない場合の処理
  if (slides.length === 0) {
    log('error', 'スライド要素が見つかりません');
    return; // 処理を終了
  }

  slides.forEach((slide, index) => {
    log('log', `スライド ${index + 1} を初期化中`);

    const summaryButton = slide.querySelector('.js-summary');
    const closeButton = slide.querySelector('.js-close-btn');
    const backdrop = slide.querySelector('.js-backdrop');
    const fullscreenBox = slide.querySelector('.js-fullscreen-box');
    let isAnimating = false;

    // 必要な要素が見つからない場合のエラー処理
    if (!summaryButton || !closeButton || !backdrop || !fullscreenBox) {
      log('error', `スライド ${index + 1} の必須要素が見つかりません`);
      return; // このスライドの処理をスキップ
    }

    // 開く・閉じるイベント設定
    summaryButton.addEventListener('click', (event) => {
      event.preventDefault();
      if (isAnimating) return;

      const isOpen = fullscreenBox.style.visibility === 'visible';
      log('log', `スライド ${index + 1} を${isOpen ? '閉じる' : '開く'}処理中`);
      isOpen ? closeContent() : openContent();
    });

    closeButton.addEventListener('click', () => {
      if (!isAnimating) closeContent();
    });

    backdrop.addEventListener('click', () => {
      if (!isAnimating) closeContent();
    });

    // 開く処理
    function openContent() {
      isAnimating = true;
      backdrop.style.visibility = 'visible';
      backdrop.style.opacity = '0';
      fullscreenBox.style.visibility = 'visible';
      fullscreenBox.style.opacity = '0';
      fullscreenBox.style.transform = 'translateX(100%)';

      requestAnimationFrame(() => {
        backdrop.style.opacity = '1';
        fullscreenBox.style.opacity = '1';
        fullscreenBox.style.transform = 'translateX(0)';
      });

      setTimeout(() => {
        isAnimating = false;
        log('log', `スライド ${index + 1} が開かれました`);
      }, 600);
    }

    // 閉じる処理
    function closeContent() {
      isAnimating = true;
      backdrop.style.opacity = '0';
      fullscreenBox.style.opacity = '0';
      fullscreenBox.style.transform = 'translateX(100%)';

      setTimeout(() => {
        backdrop.style.visibility = 'hidden';
        fullscreenBox.style.visibility = 'hidden';
        isAnimating = false;
        log('log', `スライド ${index + 1} が閉じられました`);
      }, 600);
    }
  });
});

